import * as actionTypes from '../actions/actionTypes';

export default function caseListFilter(state = {}, action) {
  switch(action.type){
    case actionTypes.SET_CASE_LIST_FILTER: {
      return action.filter;
    }
    case actionTypes.RESET_CASE_LIST_FILTER: {
      return {};
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseList/reducers/caseListFilter.js